import { Component, Input, OnInit, AfterViewInit, OnChanges } from '@angular/core';
import { Chart, ChartConfiguration, ChartItem } from 'chart.js';

import { DomSanitizer, SafeHtml, SafeUrl } from '@angular/platform-browser';
import { DevelopmentDevInfo, DevelopmentInfo } from '@interfaces/app';
import { faEnvelope, faGlobe, faHotel } from '@fortawesome/free-solid-svg-icons';

@Component({
   selector: 'mnf-project-info-developer',
   templateUrl: './project-info-developer.component.html',
   styleUrls: ['./project-info-developer.component.scss']
})
export class ProjectInfoDeveloperComponent implements OnInit, OnChanges {
   @Input() dev: DevelopmentInfo;
   @Input() selectedIndex: number;

   percentMonific: number;
   percentDeveloper: number;

   devDescription: SafeHtml;

   percentChart: Chart<'doughnut', number[], unknown>;

   developer: DevelopmentDevInfo;

   nameCompany: string;

   rewardsDev: { img: SafeUrl, title: string; }[];
   rewards: { img: SafeUrl, title: string; }[];


   websiteIcon = faGlobe;
   hotelIcon = faHotel;
   emailIcon = faEnvelope;

   constructor(private domSan: DomSanitizer) { }

   ngOnInit(): void {
      if (this.dev.monificPercent) {
         this.percentMonific = this.dev.monificPercent;
         this.percentDeveloper = 100 - this.dev.monificPercent;
      }

      if(this.dev?.developer?.description == undefined || null) {
         this.devDescription = this.domSan.bypassSecurityTrustHtml('<p></p>');
      } else {
         this.devDescription = this.domSan.bypassSecurityTrustHtml(this.dev.developer?.description);
      }

      this.developer = this.dev.developer;
      this.nameCompany = this.dev.developer.company;

      if(this.dev?.location?.rewardsDev) {
         this.rewardsDev = this.dev?.location?.rewardsDev.map(rewardsDev => { const c = rewardsDev.split('|'); return { title: c[0], img: this.domSan.bypassSecurityTrustUrl(c[1]) } });
      }

   }

   ngOnChanges(): void {
      this.createChart();
   }

   /** Función para abrir el enlances externos desde botones */
   openLink(link: string): void {
      window.open(link, '_blank');
   }

   createChart() {
      const el = (document.getElementById('percent-chart') as HTMLCanvasElement)?.getContext('2d') as ChartItem;

      if (el && !this.percentChart) {
         const data = {
            labels: [
               'Desarrollador',
               'MONIFIC',
            ],
            datasets: [{
               label: 'Porciento',
               data: [this.percentDeveloper, this.percentMonific],
               backgroundColor: [
                  '#009FB1',
                  '#0F5568',
               ],
               hoverOffset: 4
            }]
         };

         const config: ChartConfiguration<'doughnut'> = {
            type: 'doughnut',
            data: data,
            options: {
               plugins: {
                  legend: { display: false },
               }
            }
         };

         this.percentChart = new Chart(el, config);
      }
   }

   hideNameCompany(name: string ) {
      switch(name) {
         case 'POLA KAMHAGI CABABIE':
            return 'POLA *** ***';
         case 'LUIS FERNANDO SANTIAGO GARCIA':
            return 'LUIS *** *** ***';
         case 'SAMUEL ALBERTO MASLIAH TRONLLAN':
            return 'SAMUEL *** *** ***';
         default:
            return name;
      }
   }

}
